import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FaqAccordion = ({ faqs, testidPrefix = "faq" }) => (
    <Accordion type="single" collapsible className="w-full" data-testid={`${testidPrefix}-accordion`}>
        {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-white/10">
                <AccordionTrigger
                    data-testid={`${testidPrefix}-trigger-${i}`}
                    className="text-left font-display uppercase tracking-wide text-lg text-gray-200 hover:text-[#E53E3E] hover:no-underline transition-colors"
                >
                    {f.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`${testidPrefix}-content-${i}`} className="text-gray-400 text-sm leading-relaxed">
                    {f.a}
                </AccordionContent>
            </AccordionItem>
        ))}
    </Accordion>
);
